import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useWindowSize } from 'usehooks-ts';
import { SIDE_PANEL_BREAKPOINT, VEHICLE_STATUSES } from '../../constants';
import { AUTSlider } from '..';
import { VehicleSideCardMobile } from './VehicleSideCardMobile';
import { useGetSidePanelBidsQuery } from 'services/api/my-bids';
import { setActiveVehicleId, toggleCollapsed } from '../../services/sidePanel/sidePanel';
import { Icon } from '@material-ui/core';

const MobileContainer = styled.div<{ isCollapsed: boolean }>`
  border-radius: 16px 16px 0px 0px;
  background: #fff;
  padding: 16px 0;
  width: 100%;
  justify-content: center;
  position: fixed;
  z-index: 100;
  bottom: 78px;
  left: 0;
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.25);

  transition: transform 0.3s ease-in-out;
  transform: translateY(${props => (props.isCollapsed ? '100%' : '0')});

  & .slick-list {
  }
`;

const ToggleButton = styled.button<{ isCollapsed: boolean }>`
  position: fixed;
  bottom: ${props => (props.isCollapsed ? '187px' : '167px')};
  left: 50%;
  width: 40px;
  height: 40px;
  transform: translateX(-50%);
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  transition: left 0.3s ease-in-out;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #666;
  }
`;

export const VehicleSidePanelMobile = () => {
  const user = useSelector((state: any) => state.user?.user);
  const { data } = useGetSidePanelBidsQuery(undefined, { skip: !user || user.role !== 'buyer' });
  const activeVehicleId = useSelector((state: any) => state.sidePanel.activeVehicleId);
  const sliderRef = useRef<any>(null);

  const isCollapsed = useSelector((state: any) => state.sidePanel.isCollapsed);

  const dispatch = useDispatch();

  const togglePanel = () => {
    dispatch(toggleCollapsed());
  };

  const items = useMemo(
    () => data?.rows?.ids.map(id => data?.rows?.entities[id]!)?.filter(item => item.status === VEHICLE_STATUSES.ACTIVE),
    [data]
  );

  useEffect(() => {
    if (!activeVehicleId || !items) return;

    const newIndex = items.findIndex(vehicle => vehicle.id === activeVehicleId);
    sliderRef.current?.slickGoTo(newIndex > -1 ? newIndex : 0);

    dispatch(setActiveVehicleId(null));
  }, [activeVehicleId, dispatch, items]);

  const screen = useWindowSize();
  const { width = 0 } = screen ?? {};

  if (!items || items.length === 0) return null;

  const isMobile = width <= SIDE_PANEL_BREAKPOINT;
  if (!isMobile) return null;

  return (
    <MobileContainer isCollapsed={isCollapsed}>
      <ToggleButton
        isCollapsed={isCollapsed}
        onClick={togglePanel}
        aria-label={isCollapsed ? 'Expand panel' : 'Collapse panel'}
      >
        {isCollapsed ? <Icon>keyboard_arrow_up</Icon> : <Icon>keyboard_arrow_down</Icon>}
      </ToggleButton>
        <AUTSlider
          sliderRef={sliderRef}
          settings={{
            slidesToShow: 1,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            variableWidth: width > 576,
            infinite: false
          }}
        >
          {(items ?? []).map((vehicle, i) => {
            return <VehicleSideCardMobile includeIndents={width > 576} vehicle={vehicle} key={vehicle.id} />;
          })}
        </AUTSlider>
    </MobileContainer>
  );
};
